import React from 'react'
import injectSheet from 'react-jss'

const Logout = (props) => {
  const {
    classes,
    logout,
    user,
  } = props

  return (
    <div className={`${classes.logoutButtonContainer} ${!user && 'disabled'}`}>
      <div
        className={classes.logoutButton}
        role="button"
        tabIndex={0}
        onClick={logout}
        onKeyDown={() => false}
      >
        {user.email}
      </div>
    </div>
  )
}

const styles = theme => ({
  logoutButtonContainer: {
    padding: `${theme.sizes.gutter / 2}px`,
  },
  logoutButton: {
    color: theme.colors.main_3,
    cursor: 'pointer',
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
    ],
    '&:hover': {
      color: theme.colors.main_1,
    },
  },
})

export default injectSheet(styles)(Logout)



// WEBPACK FOOTER //
// ./src/modules/admin/components/logout.jsx